import { render, staticRenderFns } from "./OpportunityFees.vue?vue&type=template&id=abede910&"
import script from "./OpportunityFees.vue?vue&type=script&lang=js&"
export * from "./OpportunityFees.vue?vue&type=script&lang=js&"
import style0 from "./OpportunityFees.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports